import {getLogger} from 'loglevel';
import config from '../../js/config';
import Analytics from '../Analytics/Analytics';
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';

const log = getLogger('Video');


const trackFirstPlay = function(el) {
  if (!window.videojs) {
    log.warn('Brightcove videojs object not available');
    return;
  }

  window.videojs(el).one('timeupdate', function() {
    Analytics.push(config.analytics.events.click, config.analytics.categories.video, config.analytics.actions.play, this.currentSrc());
  });
};

export function create($parent) {
  parallelArrayEach($parent.find('.videojs'), trackFirstPlay);
}



// WEBPACK FOOTER //
// ./assets/components/BrightcoveVideoPlayer/BrightcoveVideoPlayer.js